import { TranslocoService } from '@jsverse/transloco';

export class GameTranslationService<A extends string> {
  private gameTranslations = new Map<A, string>();

  constructor(
    private translationPrefix: string,
    private translationKeys: A[],
  ) {}

  public preloadTranslations(translocoService: TranslocoService) {
    this.gameTranslations = new Map(
      this.translationKeys.map((key) => [
        key,
        translocoService.translate(`${this.translationPrefix}.${key}`),
      ]),
    );
  }

  public getTranslation(key: A): string {
    const translation = this.gameTranslations.get(key);
    if (!translation) {
      console.error(`Translation for key "${key}" not found in gameTranslations.`);
    }
    return translation ?? '';
  }
}
